const config = require('../config/config')

// IndexedDb.js
var IndexedDb = function () {
  this.DB_NAME = 'bmtv';
  // Use a long long for this value (don't use a float)
  this.DB_VERSION = 5;
  this.DB_STORE_NAMES = config.dbStores;
  this.db;
}

IndexedDb.prototype.openDB = function(Callback) {
  var self = this;

  console.log('openDb ...');
  var open = function(name, version) {
    return new Promise(function (resolve, reject) {

      var req = indexedDB.open(name, version);

      req.onupgradeneeded = function(evt) {
        console.log('onupgradedneeded');
        // console.log(evt.currentTarget.result);
        if (evt.currentTarget.result instanceof IDBDatabase) {
          var db = evt.currentTarget.result;
          for (var i in self.DB_STORE_NAMES) {
            if (!db.objectStoreNames.contains(self.DB_STORE_NAMES[i])) {
              var req = db.createObjectStore(self.DB_STORE_NAMES[i]);
            }
          }
        }
      };

      req.onerror = function (evt) {
        console.error('openDb error : ', evt.target.errorCode);
        reject(evt.target.errorCode);
      };

      req.onsuccess = function(evt) {
        // Better use "this" than "req" to get the result to avoid problems with
        // garbage collection.
        console.log("openDb DONE");
        resolve(this.result);
      };

      req.onblocked = reject;

    });
  };
  // 
  return open(this.DB_NAME, this.DB_VERSION)
    .then(function (db) {
      // use db here
      self.db = db;
      return Callback(null, self.db);
    }).catch(function (err) {
      console.log(err)
    });  
};

IndexedDb.prototype.getObjectStore = function (store_name, mode, Callback) {
  var self = this;
  return new Promise(function (resolve, reject) {
    var tx = self.db.transaction(store_name, mode);
    var store = tx.objectStore(store_name);
    resolve(store)
  }).then(function (store) {
    return Callback(null, store);
  }).catch(function (err) {
    console.log(err);
    return Callback(err);
  });
};


IndexedDb.prototype.clearDb = function (Callback) {
  var self = this;
  var DBDeleteRequest = window.indexedDB.deleteDatabase(this.DB_NAME);
  DBDeleteRequest.onerror = function (e) {
    console.log("Error deleting database", self.DB_NAME);
    return Callback(err);
  };
  DBDeleteRequest.onblocked = function () {
    console.log("Couldn't delete database " + self.DB_NAME + " due to the operation being blocked");
  };
  DBDeleteRequest.onsuccess = function (e) {
    console.log(self.DB_NAME, "database deleted successfully");
    return Callback(null, true);
  };
};


IndexedDb.prototype.clearObjectStore = function (store_name, Callback) {
  var self = this;
  return new Promise(function (resolve, reject) {
    console.log('Clearing ..', store_name);
    var transaction = self.db.transaction([store_name], 'readwrite');
    var store = transaction.objectStore(store_name);
    resolve(store) 
  }).then(function (store) {
    var req = store.clear();
    req.onsuccess = function(evt) {
      console.log('Success : Store ' + store_name + ' cleared');
      // return true;
      return Callback(null, true);
    };
    req.onerror = function (evt) {
      console.error('clearObjectStore:', evt.target.errorCode);
      console.log(this.error);
      throw this.error;
    };
  }).catch(function (err) {
    return Callback(err);
  });
};


IndexedDb.prototype.addEntry = function (obj, Callback) {
  var self = this;
  console.log("addEntry arguments:", arguments);
  return new Promise(function (resolve, reject) {
    var req;
    // console.log('Adding ..', obj);
    var transaction = self.db.transaction(["Messages"],"readwrite");
    var store = transaction.objectStore("Messages"); 
    req = store.put(obj, obj.id);
    req.onsuccess = function (evt) {
      console.log("Insertion in DB successful");
      return resolve(true);
    };
    req.onerror = function() {
      console.error("addEntry error", this.error);
      return reject(this.error);
    };
  }).then(function (store) {
    return Callback(null, true);
  }).catch(function (err) {
    return Callback(err);
  });
};


IndexedDb.prototype.getEntry = function(id, Callback) {
  var self = this;
  return new Promise(function (resolve, reject) {
    var req;
    console.log('Reading ..', id);
    var transaction = self.db.transaction(["Messages"],"readwrite");
    var store = transaction.objectStore("Messages"); 
    req = store.get(id);
    req.onsuccess = function (evt) {
      var result = evt.target.result;
      console.log('Read result', result)
      return resolve(result);
    };
    req.onerror = function() {
      console.error("getEntry error", this.error);
      return reject(this.error);
    };
  }).then(function (result) {
    return Callback(null, result);
  }).catch(function (err) {
    return Callback(err);
  });
};


IndexedDb.prototype.addUser = function (obj, Callback) {
  var self = this;
  return new Promise(function (resolve, reject) {
    var req;
    var transaction = self.db.transaction(["User"],"readwrite");
    var store = transaction.objectStore("User");  
    req = store.put(obj, 0);
    req.onsuccess = function (e) {
      console.log("Insertion in DB successful");
      return resolve(true);
    };
    req.onerror = function(e) {
      console.error("addUser error", e.target.error.name);
      return reject(false);
    };
  }).then(function (success) {    
    if (success) {
      return Callback(null, true);
    }
    return Callback('Something went wrong ...');
  }).catch(function (err) {
    return Callback(err);
  });
};


IndexedDb.prototype.getUser = function(Callback) {
  var self = this;
  return new Promise(function (resolve, reject) {
    var req;
    console.log('Reading User');
    var transaction = self.db.transaction(["User"],"readwrite");
    var store = transaction.objectStore("User");  
    req = store.get(0);
    req.onsuccess = function (e) {
      console.log("Read user in DB successful");
      var result = e.target.result;
      return resolve(result);
    };
    req.onerror = function() {
      console.error("getUser error", this.error);
      return reject(this.error);
    };
  }).then(function (result) {
    return Callback(null, result);
  }).catch(function (err) {
    return Callback(err);
  });
};


module.exports = function (APP_NAME) {
  return new IndexedDb(APP_NAME);
}




//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/models/IndexedDb.js
// module id = 83
// module chunks = 0